import masks from '../../../providers/masks';

import repository from '../../repositories/crm/crm.contact.repository';

const findAll = async () =>
    repository
        .findAll()
        .then(res => res.data || []);

const findById = async (id) =>
    repository
        .findById(id)
        .then(res => res.data || {});

const create = async (values) =>
    repository
        .create(values)
        .then(res => res.data || {});

const findByNamePartial = async (name) =>
    repository
        .findByNamePartial(name)
        .then(res => res.data || []);

const contactFields = [
    { name: 'name', label: 'Nome', required: true },
    { name: 'email', label: 'Email', required: false, helperText: '(opcional)' },
    { name: 'phone', label: 'Telefone', required: true, mask: masks.cellPhone },
]

const service = {
    findAll,
    findById,
    create,
    findByNamePartial,
    contactFields
}

export default service;